export const INPUTS = [
  {
    kind: 'input',
    type: 'email',
    name: 'email',
    sheetId: 'Email address',
  },
  {
    kind: 'input',
    type: 'text',
    name: 'name',
    sheetId: 'Name',
  },
  {
    kind: 'input',
    type: 'tel',
    name: 'phone',
    sheetId: 'Telefonnummer',
  },
  {
    kind: 'input',
    type: 'text',
    name: 'eventTitle',
    sheetId: 'Name der Veranstaltung / Title of event',
  },
  {
    kind: 'checkboxes',
    name: 'date',
    sheetId: 'Preferred date of your event // Bevorzugtes Datum deines/eures Events',
    items: [
      { id: '09.07', label: 'Wed. 09.07' },
      { id: '10.07', label: 'Thur. 10.07' },
      { id: '11.07', label: 'Fri. 11.07' },
      { id: '12.07', label: 'Sat. 12.07' },
      { id: '13.07', label: 'Sun. 13.07' },
      { id: '16.07', label: 'Wed. 16.07' },
      { id: '17.07', label: 'Thur. 17.07' },
      { id: '18.07', label: 'Fri. 18.07' },
      { id: '19.07', label: 'Sat. 19.07' },
      { id: '20.07', label: 'Sun. 20.07' },
      { id: '23.07', label: 'Wed. 23.07' },
      { id: '24.07', label: 'Thur. 24.07' },
      { id: '25.07', label: 'Fri. 25.07' },
      { id: '26.07', label: 'Sat. 26.07' },
      { id: '27.07', label: 'Sun. 27.07' },
      { id: '30.07', label: 'Wed. 30.07' },
      { id: '31.07', label: 'Thur. 31.07' },
    ],
  },
  {
    kind: 'input',
    type: 'text',
    name: 'time',
    sheetId: 'Preferred time of your event // Bevorzugte Zeit deines/eures Events',
  },
  {
    kind: 'input',
    type: 'text',
    name: 'duration',
    sheetId:
      'Estimated duration of your event (in hours incl. buildup/down, soundcheck) // Ungefähre Dauer deines/eures Events (in Stunden inkl. Auf/Abbau, Soundcheck)',
  },
  {
    kind: 'checkboxes',
    name: 'venue',
    sheetId: 'Preferred venue at Rote Fabrik // Gewünschter Raum in der Roten Fabrik',
    items: [
      { id: 'radioVenue', label: 'Radio (1 Mic, 2 CDJ, 2 RP, 1 DJ-Mixer, Monitoring)' },
      { id: 'club', label: 'Clubraum (only available on Wednesdays & Sundays - see Techrider below)' },
      { id: 'foyer', label: 'Foyer Clubraum (no Techrider, small Workshops, Gatherings, Actions)' },
      { id: 'courtyard', label: 'Courtyard (only silent events)' },
      { id: 'atelier', label: 'Atelier (for Workshops, Gatherings, Actions, super reduced Techrider)' },
    ],
  },
  {
    kind: 'checkboxes',
    name: 'eventType',
    sheetId: 'Type of your event // Art deiner/eurer Veranstaltung',
    items: [
      { id: 'art', label: 'Art (exhibition / performance) // Kunst (Ausstellung / Performance)' },
      { id: 'discourse ', label: 'Discourse // Diskurs' },
      { id: 'workshop ', label: 'Workshop (skill-sharing // Wissenstransfer)' },
      { id: 'action ', label: 'Action // Aktion' },
      { id: 'radio', label: 'Radio' },
      { id: 'concert', label: 'Concert // Konzert' },
      { id: 'otherType', label: 'other' },
    ],
  },
  {
    kind: 'input',
    type: 'text',
    name: 'description',
    sheetId: 'Beschreibung Event / event description',
  },
  {
    kind: 'input',
    type: 'text',
    name: 'additionalInfo',
    sheetId:
      'Additional Information about your event (like info about your collective, RSVP-link, etc. / will be displayed below description) // Zusatzinfos zu deinem Event (wie zB. Info zu eurer Gruppe, Reservationslink, etc. / wird unter der Beschreibung auf der Website angezeigt)',
  },
  {
    kind: 'input',
    type: 'text',
    name: 'artists',
    sheetId: 'Involved artists, guests, performers // Involvierte Künstler*innen, Gäste*, Performer*innen',
  },
  {
    kind: 'input',
    type: 'text',
    name: 'instagram',
    sheetId: 'Instagram-Handles',
  },
  {
    kind: 'input',
    type: 'text',
    name: 'timetable ',
    sheetId: 'Programme schedule / Timetable of your event',
  },
  {
    kind: 'checkboxes',
    name: 'technical',
    sheetId: 'Technical needs (Clubraum only!) // Technische Bedürfnisse (nur im Clubraum!)',
    items: [
      { id: 'sound_system', label: '2-point Meyer-Soundsystem' },
      { id: 'dj', label: 'DJ-Setup: Pioneer DJM 900 nxs, 2 Pioneer CDJ 2000 nxs2, 2 Pioneer PLX1000, Monitoring' },
      { id: 'mic', label: '4 radio microphones // Funk-Miks' },
      { id: 'stereo', label: 'Stereo-In (Plug-Ins)' },
      { id: 'screen', label: 'Beamer & screen // Leinwand' },
      { id: 'printer', label: 'b/w-printer // s/w-Drucker' },
      { id: 'light_discourse', label: 'light preset "discourse" / Licht-Preset "Diskurs"' },
      { id: 'light_clubroom', label: 'light preset "club" / Club-Licht-Preset' },
      { id: 'chairs', label: 'stools & chairs // Sitzhocker & Stühle' },
      { id: 'backstage', label: 'Backstage' },
      { id: 'other', label: 'other' },
    ],
  },
  {
    kind: 'input',
    type: 'text',
    name: 'comment',
    sheetId: 'Any other needs or comments? // Hast du weitere Bedürfnisse oder Kommentare?',
  },
];
